import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../globalStore/user.slice';
import userPasskeysReducer from '../globalStore/userPasskeys.slice';
import fileViewerDialogReducer from '../Components/FileViewerDialog/fileViewerDialog.slice';
import identityVerificationReducer from '../Components/IdentityVerification/identityVerification.slice';
import electronicSignatureCreationReducer from '../Components/ElectronicSignatureCreation/electronicSignatureCreation.slice';
import livenessReducer from '../Components/Liveness/liveness.slice';
import documentSignatureReducer from '../Components/DocumentSignature/documentSignature.slice';
import videoAgreementReducer from '../Components/VideoAgreement/videoAgreement.slice';
import userSummaryReducer from '../Components/UserSummary/userSummary.slice';
import fileHistoryReducer from '../Components/FileHistory/fileHistory.slice';
import authenticatorAppReducer from '../Components/Profile/ProfileAuthentication/AuthenticatorApp/authenticatorApp.slice';
import passkeysReducer from '../Components/Profile/ProfileAuthentication/Passkeys/passkeys.slice';
import loginReducer from '../Components/Login/login.slice';
import privacyNoticeOnboardingReducer from '../Components/PrivacyNoticeOnboarding/privacyNoticeOnboarding.slice';
import twoFactorOnboardingReducer from '../Components/TwoFactorOnboarding/twoFactorOnboarding.slice';

export const mainStore = configureStore({
  reducer: {
    user: userReducer,
    userPasskeys: userPasskeysReducer,
    fileViewerDialog: fileViewerDialogReducer,
    identityVerification: identityVerificationReducer,
    electronicSignatureCreation: electronicSignatureCreationReducer,
    liveness: livenessReducer,
    documentSignature: documentSignatureReducer,
    videoAgreement: videoAgreementReducer,
    userSummary: userSummaryReducer,
    fileHistory: fileHistoryReducer,
    authenticatorApp: authenticatorAppReducer,
    passkeys: passkeysReducer,
    login: loginReducer,
    privacyNoticeOnboarding: privacyNoticeOnboardingReducer,
    twoFactorOnboarding: twoFactorOnboardingReducer,
  },
});
